import { Link } from 'react-router-dom';

import { getMessage } from 'common/helpers/miscHelper';

const ContinueAsGuest = (props) => {
  const { settings } = props;
  return (
    <div className="c7-account-login--new">
      <h4>Continue as guest</h4>
      <p>{getMessage('Checkout Create Account', settings)}</p>
      <p>
        <Link to="/checkout/checkout" className="c7-button">
          Continue as guest
        </Link>
      </p>
    </div>
  );
};

export default ContinueAsGuest;
